const contextActionType = {
    SET_STYLES_OPEN: "SET_STYLES_OPEN",
    GET_STYLES_OPEN: "GET_STYLES_OPEN",
    SET_ACTIVE_PLAYER: "SET_ACTIVE_PLAYER",
    GET_ACTIVE_PLAYER: "GET_ACTIVE_PLAYER",
    OPEN_SHORT_PRESET: "OPEN_SHORT_PRESET",
    CLOSE_SHORT_PRESET: "CLOSE_SHORT_PRESET",
    GET_PRESET_MODAL_OPEN: "GET_PRESET_MODAL_OPEN",
    GET_PLAYER_REMOUNT_KEY: "GET_PLAYER_REMOUNT_KEY",
};

export default contextActionType; 